/**
 * Product media component
 * 
 * @module product-media
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'component-product-media';

if (!customElements.get(customElements.component)) {
    class productMediaComponent extends HTMLElement {

        /**
         * Product media web component.
         * 
         * @constructor
         */
        constructor() {

            super();

            /**
             * Media element.
             * 
             * @var {Object}
             */
            this.media = this.querySelector('[data-media]');

            /**
             * Thumbnails element.
             * 
             * @var {Object}
             */
            this.thumbnails = this.querySelector('[data-thumbnail-slider]');

            this.initCells();
            this.initSlider();
            this.initEvents();
            this.initPhotoSwipeEvents();
        }

        /**
         * Init media cells array to handle image visibility on change variant.
         * 
         * @returns {undefined}
         */
        initCells() {

            /**
             * Media cells array
             * 
             * @var {Array}
             */
            this.cells = [];

            /**
             * Number of visible cells in the media based of the variant selected.
             * 
             * @var {Array}
             */
            this.activeCells = 0;

            this.media.querySelectorAll('[data-media-item]').forEach(item => {

                let index = item.dataset.mediaItemIndex;

                this.cells[index] = {
                    index: parseInt(index),
                    status: true,
                    alt: item.dataset.mediaItem,
                    element: item
                };
            });
        }

        /**
         * Init media slider.
         * 
         * @returns {undefined}
         */
        initSlider() {

            this.querySelectorAll('.swiper-lazy-loading').forEach(element => {
                element.classList.remove('swiper-lazy-loading');
            });

            const swiperMediaPagination = this.media.querySelector('.swiper-media-pagination');
            const swiperScrollbar = this.media.querySelector('.swiper-scrollbar');

            let disableSwiperDesktop = this.dataset.disableSwiperDesktop || "false";

            let defaultOptions = {
                preloadImages: true,
                lazy: {
                    loadPrevNext: true,
                },
                autoHeight: true,
                pagination: {
                    el: swiperMediaPagination,
                    dynamicBullets: true
                },
                scrollbar: {
                    el: swiperScrollbar,
                },
                on: {
                    init: () => {

                        if (!this.thumbnails)
                            return false;

                        this.items = this.thumbnails.querySelectorAll('[data-thumbnail-item]');

                        this.initThumbnails();

                        if (typeof window.theme.carousel != 'undefined')
                            window.theme.carousel.loadInfinityDots(this);
                    },
                    slideChange: index => {

                        if (!this.thumbnails)
                            return false;

                        this.activeThumbnail(index);

                        if (typeof window.theme.carousel != 'undefined')
                            window.theme.carousel.loadInfinityDots(this);
                    },
                    resize: () => {
                        if((disableSwiperDesktop)&&(window.screenMode == 'desktop')){
                            this.slider.activeIndex = 0;
                        }
                    }
                }
            }

            let options = (this.dataset.options) ? JSON.parse(this.dataset.options) : {};

            this.options = {...defaultOptions, ...options};

            this.slider = new Swiper(this.media, this.options);
        }

        /**
         * Init media events.
         * 
         * @returns {undefined}
         */
        initEvents() {

            // On variant change
            window.addEventListener('variant-change', event => {
                if(event.detail.product.id ==  parseInt(this.dataset.productMediaId)){
                    this.swapImages(event.detail.product, event.detail.variant);
                }
            });
        }

        /**
         * Init media thumbnails.
         * 
         * @returns {undefined}
         */
        initThumbnails() {

            const slidesPerView = this.thumbnails.dataset.slidesPerView;
            const productsSlide = this.thumbnails.querySelector('.product-media__product-thumbnails');
            const swiperButtonNext = this.thumbnails.querySelector('.swiper-button-next');
            const swiperButtonPrev = this.thumbnails.querySelector('.swiper-button-prev');

            this.slideThumbnails = new Swiper(productsSlide, {
                direction: 'horizontal',
                slidesPerView: slidesPerView,
                preloadImages: true,
                autoHeight: false,
                navigation: {
                    nextEl: swiperButtonNext,
                    prevEl: swiperButtonPrev,
                }
            });

            //Mark the first element as active
            this.thumbnails.querySelector('[data-thumbnail-item]').classList.add("active");

            this.items.forEach(element => {

                element.addEventListener('click', event => {

                    event.preventDefault();

                    let index = element.dataset.thumbnailIndex;

                    this.activeThumbnail(index);

                    this.slider.slideTo(index, 500);

                }, false);
            });
        }

        /**
         * Active thumbnail by index.
         * 
         * @param {integer} index Thumbnail index.
         * @returns {undefined}
         */
        activeThumbnail(index) {

            this.slideThumbnails.slideTo(index.activeIndex, 500);
          
          const currentActiveImage = document.querySelector('.product-media__item.swiper-slide-active img'),
                currentImageUrl = currentActiveImage.getAttribute('src'),
                currentImagePswp = currentActiveImage.getAttribute('data-pswp-src');
          if(currentImageUrl != currentImagePswp) {
            currentActiveImage.setAttribute('src', currentImagePswp);
          } 
        }

        /**
         * Swap media images by variant.
         * @param {object} product Product data.
         * @param {object} variant Variant data.
         * @returns {undefined}
         */
        swapImages(product, variant) {
            let alt = this.getCurrentAlt(product, variant);
            if (alt) {
                this.destroySlider();
                this.activeCells = 0;
                this.cells.forEach(cell => {
                    if (cell.alt && cell.alt.toLowerCase() == alt.toLowerCase()) {                        
                        this.enableImage(cell.index);
                        this.activeCells++;
                    } else {
                        this.disableImage(cell.index);
                    }
                });

                this.updateThumbnailsVisibility(alt);

            }else {
                if(variant.option2){
                    let first = document.querySelector('[data-media-item-index="0"] img');
                    first.setAttribute('src',variant.featured_media.preview_image.src);
                    first.setAttribute('data-pswp-width',variant.featured_media.preview_image.width);
                    first.setAttribute('width',variant.featured_media.preview_image.width);
                    first.setAttribute('data-pswp-height',variant.featured_media.preview_image.height);
                    first.setAttribute('height',variant.featured_media.preview_image.height);
                }else{
                    this.showAllImages();
                    this.initSlider();
                }
            }
        }

        /**
         * Get image alt from current variant active.
         * 
         * @param {object} product Product data.
         * @param {object} variant Variant data.
         * @returns {string} Image alt.
         */
         getCurrentAlt(product, variant) {

            let currentAlt = null;

            if (product.media) {
                product.media.forEach(image => {

                    if (image.alt && variant) {

                        let alt       = image.alt.toLowerCase(),
                            altArray  = alt.split('/'),
                            reference = (altArray[1]) ? altArray[1].trim() : null;
                        if (variant.title.toLowerCase().includes(reference) && !alt.includes('swatch')) {
                            currentAlt = alt;
                        } 
                            
                    }
                });

                return currentAlt;
            } 
        }

        /**
         * Destroy media slider.
         * 
         * @returns {undefined}
         */
        destroySlider() {

            this.slider.destroy();
        }

        /**
         * Disable image by media cell index.
         * 
         * @param {integer} index Media cell index.
         * @returns {undefined}
         */
        disableImage(index) {
            
            this.cells[index].status = false;

            let element = this.querySelector('[data-media-item-index="'+ index +'"]');

            if (element) {
                element.remove();
            }
        }

        /**
         * Enable image by media cell index.
         * 
         * @param {integer} index Media cell index.
         * @returns {undefined}
         */
        enableImage(index) {

            this.cells[index].status = true;

            if (!this.querySelector('[data-media-item-index="' + index + '"]')) {

                this.media.querySelector('[data-media-wrapper]').append(this.cells[index].element);
            }
        }

        /**
         * Enable thumbnail element.
         * 
         * @param {object} thumbnail Thumbnail element.
         * @param {integer} index Thumbnail index.
         * @returns {undefined}
         */
        enableThumbnail(thumbnail, index) {
            thumbnail.style.display = 'block';
            thumbnail.dataset.thumbnailIndex = index;
        }

        /**
         * Disable thumbnail element.
         * 
         * @param {object} thumbnail Thumbnail element.
         * @returns {undefined}
         */
        disableThumbnail(thumbnail) {
            thumbnail.dataset.thumbnailIndex = -1;
            thumbnail.style.display = 'none';
        }

        /**
         * Active thumbnail by a custom click event.
         * 
         * @param {object} thumbnail Thumbnail element.
         * @returns {undefined}
         */
        triggerThumbnailClick(thumbnail) {
            let event = new CustomEvent('click', {});
            thumbnail.dispatchEvent(event);
            return true;
        }

        /**
         * Show all media images.
         * 
         * @param {object} thumbnail Thumbnail element.
         * @returns {undefined}
         */
        showAllImages() {

            // Disable all images
            this.cells.forEach((cell, index) => {
                this.disableImage(index);
            });

            // Display all images except swatches
            this.cells.forEach((cell, index) => {
                if (cell.alt && cell.alt.toLowerCase().includes('swatch')) {
                    this.disableImage(index);
                } else {
                    this.enableImage(index);
                }
            });

            // Display all thumbnails except swatches
            this.updateThumbnailsVisibility();
        }

        /**
         * Update thumbnails visibility by image alt.
         * 
         * @param {string} alt Image alt.
         * @returns {undefined}
         */
        updateThumbnailsVisibility(alt) {
            
            let activeThumbnail = false, index = 0;

            document.querySelectorAll('[data-thumbnail-item]').forEach(thumbnail => {

                if (thumbnail.dataset.thumbnailItem) {

                    // Display thumbnails via alt
                    if (alt) {

                        if (thumbnail.dataset.thumbnailItem.toLowerCase() == alt.toLowerCase()) {

                            this.enableThumbnail(thumbnail, index);
        
                            index++;
            
                            if (!activeThumbnail)
                                activeThumbnail = this.triggerThumbnailClick(thumbnail);

                        } else {

                            this.disableThumbnail(thumbnail);

                        }

                    } else {

                        // Display all thumbnails except swatches
                        if (!thumbnail.dataset.thumbnailItem.toLowerCase().includes('swatch')) {
            
                            this.enableThumbnail(thumbnail, index);
                
                            index++;
        
                            if (!activeThumbnail)
                                activeThumbnail = this.triggerThumbnailClick(thumbnail);
                        }
                    }

                } else {

                    this.disableThumbnail(thumbnail);
                }
            });
        }

        /**
         * Init PhotoSwipe events.
         * 
         * @returns {undefined}
         */
        initPhotoSwipeEvents() {
            // Init zoom image
            let zoomImage = document.querySelectorAll('[data-pswp-img]');

            this.initZoomImage(zoomImage);

            // On screen change
            window.addEventListener('screen-breakpoint', event => {
                this.initZoomImage(zoomImage);
            });
        }

        /**
        * Start zoom with PhotoSwipe gallery on product image
        * 
        * @param {object} zoomImage Images that will init zoom.
        * @returns {undefined}
        */

        initZoomImage(zoomImage) {
            if(window.screenMode == 'tablet' || window.screenMode == 'desktop'  || window.screenMode == 'desktop-large' ) {
                //active on tablet, desktop and desktop-large devices by clicking the zoom button
                let zoomList = document.querySelectorAll('[data-zoom]');

                if(zoomList){
                    zoomList.forEach((zoomBtn) => {

                        if(zoomBtn && !zoomBtn.classList.contains('zoom-active') ){
                            zoomBtn.classList.add('zoom-active');
        
                            //init the zoom PhotoSwipe starting with the selected image
                            zoomBtn.addEventListener('click', (event) => {
                                let indexImg = zoomBtn.dataset.zoomImgIndex;
                                this.initPhotoSwipe(zoomImage, indexImg);
                            });
                        }
                        
                    });
                }

            } else {

                // active on mobile by clicking the image
                zoomImage.forEach((element, index) => {
                    if (!element.classList.contains('zoom-active')) {
                        element.classList.add('zoom-active');

                        //init the zoom PhotoSwipe starting with the selected image
                        element.addEventListener('click', (event) => {
                            this.initPhotoSwipe(zoomImage, index);
                        });
                    }
                });
            }
        }

        /**
         * Init the PhotoSwipe
         * 
         * @param {object} zoomImage Images that will init PhotoSwipe.
         * @param {integer} index Image index where the PhotoSwipe will start.
         * @returns {undefined}
         */

        initPhotoSwipe(zoomImage, index) {

            let items = [];

            zoomImage.forEach((element) => {
                let img = { 
                    src: element.dataset.pswpSrc,
                    w: element.dataset.pswpWidth,
                    h: element.dataset.pswpHeight
                };
                items.push(img);
            });

            let pswpElement = document.querySelector('.pswp');

            let options = {
                tapToClose: true,
                fullscreenEl: true,
                shareEl: false,
                index: index
            };

            let gallery = new PhotoSwipe( pswpElement, window.PhotoSwipeUI_Default, items, options);

            gallery.init();

        }

    }

    customElements.define(customElements.component, productMediaComponent);
}
